import {
    BACStep1Body,
    SmallGreyText,
} from '@/src/modules/build-a-card/StyledComponents'
import GiftBoxWithCard from '@/src/modules/gift-box/content/GiftBoxWithCard'
import NextLink from 'next/link'
import { styled } from '@/src/stitches.config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import { DesktopOnly } from '@/src/common/utilities/viewportDisplay'
import CtaButtons from '@/src/modules/gift-box/buttons/CtaButtons'

const BackButton = styled('div', {
    cursor: 'pointer',
    marginBottom: 20,
    '&:hover': {
        color: '$primary',
        textDecoration: 'underline',
    },
})

const BoxStep2LeftContent = () => {
    return (
        <>
            <NextLink href={'/visa-gift-card-box'} passHref>
                <BackButton>
                    <FontAwesomeIcon
                        icon={faArrowLeft}
                        style={{ marginRight: '0.5rem' }}
                    />
                    &nbsp;Back
                </BackButton>
            </NextLink>
            <h1 style={{ marginTop: 0 }}>
                Personalize your{' '}
                <span className={'gradient'}>PerfectGift Box!</span>
            </h1>
            <GiftBoxWithCard showPreviewBoxes={true} priority={true} />
            <BACStep1Body>
                <p className={'build-message'}>
                    Create your own card design or use one of our professional
                    quality predesigns. Cards will be delivered as a bundle in a
                    single box.{' '}
                    <span className={'bold'}>Printed and shipped same-day</span>{' '}
                    for orders placed by 4pm ET (Mon-Sat).
                </p>
                <SmallGreyText>
                    Images subject to review in accordance with our{' '}
                    <a href={'/image-guidelines'}>image guidelines</a>.
                    <br />
                    For use in US only.
                </SmallGreyText>
                <DesktopOnly>
                    <CtaButtons />
                </DesktopOnly>
            </BACStep1Body>
        </>
    )
}

export default BoxStep2LeftContent
